import { render, staticRenderFns } from "./departStatic.vue?vue&type=template&id=c6089544&scoped=true&"
import script from "./departStatic.vue?vue&type=script&lang=js&"
export * from "./departStatic.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/evaluation/static.less?vue&type=style&index=0&id=c6089544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6089544",
  null
  
)

component.options.__file = "departStatic.vue"
export default component.exports